export default __webpack_public_path__ + "static/media/mdi_coffee-maker-check-outline.010d5f0d.svg";